// extracted by mini-css-extract-plugin
export default {"wrapper":"_A-z","viewport":"aB-z","container":"bB-z","slide":"cB-z"};